import { Image } from "@/Components/common/Image"
import { Msg } from "@/Components/Msg"
import { Collapse } from "@/NewComponents/Collapse"
import { useState } from "react"

interface IFaqCollapseProps {
  content: string
  title: string
}
export const FaqCollapse = ({ content, title }: IFaqCollapseProps) => {
  const [show, setShow] = useState(false)
  return (
    <li className="faq-list__item">
      <div className="faq-list__box faq-collapse__toggler" onClick={() => setShow(!show)}>
        <h5 className="faq-list__title">
          <Msg id={title} />
        </h5>
        <span className="faq-list__link ">
          <Image src="arrow-link.svg" />
        </span>
      </div>
      <Collapse className="faq-list__text" open={show} style={{ marginBottom: 0 }}>
        <Msg id={content} />
      </Collapse>
    </li>
  )
}
